import { z } from '@betty/toolkit/api';
import { PromoTargetSchema } from '../../services/PromosService.schemas';
import icons from '@betty/moonlight/lib/assets/icons';

export const rewardBadgeMap: Partial<
  Record<z.infer<typeof PromoTargetSchema>, keyof typeof icons>
> = {
  FreeSpins: 'freeSpins',
  Coins: 'bettyCoin',
  InstantWheel: 'rewardWheel',
  Cash: 'bettyDollar',
};
